import React from 'react';

import ArticleListingItem from '$partials/items/article-listing-item';
import { Carousel, CarouselWrapper } from '$partials/base/carousel';
import { SwiperSlide } from 'swiper/react';
import IconChevron from '$partials/icons/icon-chevron';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/articles.d.ts').ArticleListingGridCompact}
 */
const ArticleListingGridCompact = (props) => {
    return (
        <>
            <section className='module-article-carousel py-48'>
                <div className='layout-container layout-site-outer-padding flex items-baseline'>
                    {props.heading && (
                        <h3 className='type-style-2'>
                            {props.heading}
                        </h3>
                    )}
                    {props.listingLink && (
                        <div className='ml-auto mr-0 hidden sm:block'>
                            <a
                                className='inline-flex type-style-eyebrow items-center'
                                href={props.listingLink.url}>
                                {props.listingLink.title}
                                <span aria-hidden={true}>
                                    <IconChevron className='ml-10 -rotate-90' />
                                </span>
                            </a>
                        </div>
                    )}
                </div>
                {props.items.edges?.length > 0 && (
                    <>
                        <div className='layout-container layout-site-outer-padding'>
                            <div className='-mx-24 mt-32 md:mt-48'>
                                {/* MD listing */}
                                <div className='hidden md:grid md:grid-cols-3 gap-y-40'>
                                    {props.items.edges.map((edge, i) => {
                                        if (i >= props.maxItem) {
                                            return null;
                                        }
                                        return (
                                            <article
                                                className={`px-24 border-l border-l-tint-dark ${i % 3 === 0 ? 'border-opacity-0' : 'border-opacity-20'}`}
                                                key={edge.node.id}>
                                                <ArticleListingItem {...edge.node}/>
                                            </article>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        {/* mobile/tablet listing carousel */}
                        <div className='md:hidden overflow-hidden w-full max-w-screen left-1/2 relative -translate-x-1/2'>
                            <div className='layout-container layout-site-outer-padding overflow-visible'>
                                <div className='col-wrapper'>
                                    <Carousel swiperConfig={{
                                        slidesPerView: 'auto',
                                        spaceBetween: 0
                                    }}>
                                        <CarouselWrapper>
                                            {(() => {
                                                const renderedCount = Math.min(
                                                    props.items.edges.length,
                                                    props.maxItem ?? props.items.edges.length
                                                );

                                                return props.items.edges.map((edge, i) => {
                                                    if (i >= props.maxItem) {
                                                        return null;
                                                    }
                                                    const isLast = i === renderedCount - 1;
                                                    return (
                                                        <SwiperSlide
                                                            className='w-10/12 sm:w-5/12 md:w-4/12 flex'
                                                            key={edge.node.id || i}>
                                                            <ArticleListingItem
                                                                className='col-padding'
                                                                isCarouselItem={true}
                                                                {...edge.node} />
                                                            <div className={`shrink-0 w-[1px] h-full bg-main-border ${isLast ? 'hidden' : ''}`} />
                                                        </SwiperSlide>
                                                    );
                                                });
                                            })()}
                                        </CarouselWrapper>
                                    </Carousel>

                                </div>
                            </div>
                        </div>
                    </>
                )}
            </section>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default ArticleListingGridCompact;
